import { NgModule } from "@angular/core";
import { ButtonModule } from "@components/button";
import { PopUpModule } from "@components/pop-up";
import { CommonModule } from "@angular/common";
import { CsIconModule } from "@components/icon";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoadingModule } from "@components/loading";
import { HttpClientModule } from "@angular/common/http";
import { RegimenConcernSelectionModule } from "@shared/regimen-concern-selection/regimen-concern-selection.module";

import { OnboardingLocationComponent } from "./onboarding-location/onboarding-location.component";
import { OnboardingGenderComponent } from "./onboarding-gender/onboarding-gender.component";
import { OnboardingMobileNumberComponent } from "./onboarding-number/onboarding-mobile-number.component";
import { OnboardingMobileOtpComponent } from "./onboarding-otp/onboarding-mobile-otp.component";
import { OnboardingConcernComponent } from "./onboarding-concern/onboarding-concern.component";
import { NoCopyDirective } from "@shared/no-copy/no-copy.directive";
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import {
  onboardingAgePageGuard,
  onboardingProfileBreakdownGuard,
} from "../guards/onboarding-profile-breakdown.guard";
import { OnboardingProfileGenderComponent } from "./onboarding-profile/onboarding-profile-gender/onboarding-profile-gender.component";
import { OnboardingProfileNameComponent } from "./onboarding-profile/onboarding-profile-name/onboarding-profile-name.component";
import { OnboardingProfileAgeComponent } from "./onboarding-profile/onboarding-profile-age/onboarding-profile-age.component";
import { OnboardingProfileShellComponent } from "./onboarding-profile/onboarding-profile-shell/onboarding-profile-shell.component";
import { OnboardingConcernCardComponent } from "./onboarding-concern/onboarding-concern-card/onboarding-concern-card.component";

/** Exported so a spec can assert the order-sensitive `/onboarding/gender` pair. */
export const onboardingRoutes: Routes = [
      {
        path: "onboarding",
        children: [
          {
            path: "",
            pathMatch: "full",
            redirectTo: "/",
          },
          {
            path: "gender",
            canMatch: [onboardingProfileBreakdownGuard],
            component: OnboardingProfileGenderComponent,
            data: { openedPage: { pageName: "onboarding-profile-gender" } },
          },
          {
            path: "gender",
            component: OnboardingGenderComponent,
          },
          {
            path: "name",
            canMatch: [onboardingProfileBreakdownGuard],
            component: OnboardingProfileNameComponent,
            data: { openedPage: { pageName: "onboarding-profile-name" } },
          },
          {
            path: "age",
            canMatch: [onboardingAgePageGuard],
            component: OnboardingProfileAgeComponent,
            data: { openedPage: { pageName: "onboarding-profile-age" } },
          },
          {
            path: "number",
            component: OnboardingMobileNumberComponent,
            data: { openedPage: { pageName: "mobile_number_login" } },
          },
          {
            path: "otp",
            component: OnboardingMobileOtpComponent,
            data: { openedPage: { pageName: "OTP" } },
          },
          {
            path: "concern",
            component: OnboardingConcernComponent,
          },
          {
            path: "location",
            component: OnboardingLocationComponent,
          },
        ],
      },
];

@NgModule({
  imports: [
    RouterModule.forChild(onboardingRoutes),
    NoCopyDirective,
    ButtonModule,
    CsIconModule,
    PopUpModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LoadingModule,
    ButtonModule,
    RegimenConcernSelectionModule,
    PopUpModule,
    ButtonCtaComponent,
    OnboardingProfileShellComponent,
    OnboardingConcernCardComponent,
  ],
  declarations: [
    OnboardingLocationComponent,
    OnboardingMobileNumberComponent,
    OnboardingMobileOtpComponent,
    OnboardingGenderComponent,
    OnboardingConcernComponent,
  ],
  exports: [OnboardingConcernComponent],
})
export class OnboardingModule {}
